import { ReactNode, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useOpenArtistView } from 'hooks/artist/useOpenArtistView';
import { useOpenCollectionView } from 'hooks/collection/useOpenCollectionView';
import { useOpenNftView } from 'hooks/nft/useOpenNftView';
import * as Styled from './styles';
import placeholderImage from 'assets/images/collections/logo-image-placeholder.svg';
import { ICollection, ICreatorInfo, INft } from 'interfaces';

type SearchListItemProps = {
  nft?: INft;
  collection?: ICollection;
  creator?: ICreatorInfo;
  children?: ReactNode;
};

export const SearchListItem = ({
  nft,
  collection,
  creator,
  children
}: SearchListItemProps): JSX.Element => {
  const { handleOpenNft } = useOpenNftView();
  const { handleOpenCollection } = useOpenCollectionView();
  const { handleOpenArtist } = useOpenArtistView();
  const { t } = useTranslation();

  const handleOpenItem = useCallback(() => {
    if (nft) {
      handleOpenNft(nft.url_key);
    }
    if (collection) {
      handleOpenCollection(collection.slug);
    }
    if (creator) {
      handleOpenArtist(creator.user_name.toString());
    }
  }, [nft, collection, creator]);
  return (
    <Styled.ItemWrapper onClick={handleOpenItem}>
      <Styled.ItemImage
        src={
          collection?.logo_image ||
          nft?.media?.small ||
          creator?.logo_url ||
          placeholderImage
        }
        preview={false}
        alt={t('collection.collectionLogo')}
      />
      <Styled.ItemCaption>
        <Styled.ItemName>
          {nft?.name || collection?.name || creator?.user_name}
        </Styled.ItemName>
        {children}
      </Styled.ItemCaption>
    </Styled.ItemWrapper>
  );
};
